const TENANT_STORAGE_KEY = "devtoolbar:tenant";
const TENANT_META_SELECTOR = 'meta[name="aurem-tenant"]';

const canUseLocalStorage = (): boolean => typeof localStorage !== "undefined";

export const getStoredTenant = (): string | undefined => {
  if (!canUseLocalStorage()) return undefined;
  return localStorage.getItem(TENANT_STORAGE_KEY) ?? undefined;
};

export const setStoredTenant = (name: string): void => {
  if (canUseLocalStorage()) {
    localStorage.setItem(TENANT_STORAGE_KEY, name);
  }
};

export const clearStoredTenant = (): void => {
  if (canUseLocalStorage()) {
    localStorage.removeItem(TENANT_STORAGE_KEY);
  }
};

export function getTenantFromDocument(): string | undefined {
  if (typeof document === "undefined") return undefined;

  const tenant = document
    .querySelector<HTMLMetaElement>(TENANT_META_SELECTOR)
    ?.content.trim();

  return tenant || undefined;
}

export function getTenantHeaderValue(): string | undefined {
  const stored = getStoredTenant();
  if (stored) return stored;

  return getTenantFromDocument();
}
